import IconButton from "@mui/material/IconButton";

import HomeIcon from "@mui/icons-material/Home";
import Backdrop from "@mui/material/Backdrop";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import eight from "../assets/img/numbers/eight.png";
import eleven from "../assets/img/numbers/eleven.png";
import fifteen from "../assets/img/numbers/fifteen.png";
import five from "../assets/img/numbers/five.png";
import four from "../assets/img/numbers/four.png";
import fourteen from "../assets/img/numbers/fourteen.png";
import nine from "../assets/img/numbers/nine.png";
import one from "../assets/img/numbers/one.png";
import seven from "../assets/img/numbers/seven.png";
import seventeen from "../assets/img/numbers/seventeen.png";
import six from "../assets/img/numbers/six.png";
import sixteen from "../assets/img/numbers/sixteen.png";
import ten from "../assets/img/numbers/ten.png";
import thirteen from "../assets/img/numbers/thirteen.png";
import three from "../assets/img/numbers/three.png";
import twelve from "../assets/img/numbers/twelve.png";
import two from "../assets/img/numbers/two.png";
import loadingImage from "../assets/loadingImage.json";
import nextGIF from "../assets/nextGIF.json";
import previousGIF from "../assets/previousGIF.json";
import "./SelectSDGsNum.css";
const SelectSDGsNum = ({ setNum, setPageNum, pageNum, play }) => {
  const navigate = useNavigate();
  const dispatcher = useDispatch();
  const [open, setOpen] = useState(false);
  const isLong = useMediaQuery({ query: "(min-height: 630px)" });
  const isWide = useMediaQuery({ query: "(min-width: 600px)" });
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setOpen(true);
  }, []);

  useEffect(() => {
    setOpen(true);
    let timer1 = setTimeout(() => setOpen(false), 1.3 * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, [pageNum]);
  const goToAdvance = (num) => {
    play();
    setNum(num);
    navigate("/advanced");
  };
  const pageChange = (num) => {
    play();
    setPageNum(num);
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}
    >
      <div
        className="play-page"
        style={isWide ? { margin: "auto", width: "75%" } : {}}
      >
        <div
          className={isWide ? "head-bar-wide" : "head-bar"}
          style={{ justifyContent: "space-between" }}
        >
          <IconButton
            onClick={() => {
              play();
              navigate("/");
              setPageNum(1);
            }}
          >
            <HomeIcon
              className={isWide ? "home-button-wide" : "home-button"}
            ></HomeIcon>
          </IconButton>
        </div>
      </div>
      {pageNum === 1 && (
        <div style={{ marginBottom: "auto" }}>
          <div
            style={{ fontSize: isLong ? "2rem" : "1.5rem", fontWeight: "600" }}
          >
            SDGs番号を選んでね!
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "55vh",
              }}
            >
              <div>
                <img
                  src={one}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(1);
                  }}
                />
              </div>
              <div>
                <img
                  src={two}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(2);
                  }}
                />
              </div>
              <div>
                <img
                  src={three}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(3);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={four}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(4);
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "55vh",
              }}
            >
              <div>
                <img
                  src={five}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(5);
                  }}
                />
              </div>
              <div>
                <img
                  src={six}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(6);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={seven}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(7);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={eight}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(8);
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "15vh",
              }}
            >
              <div>
                <Lottie
                  style={
                    isLong
                      ? {
                          width: "7rem",
                          height: "7rem",
                          margin: "auto",
                          cursor: "pointer",
                        }
                      : {
                          width: "5rem",
                          height: "5rem",
                          margin: "auto",
                          cursor: "pointer",
                        }
                  }
                  animationData={nextGIF}
                  onClick={() => {
                    pageChange(2);
                  }}
                ></Lottie>
              </div>
            </div>
          </div>

          <div></div>
        </div>
      )}

      {pageNum === 2 && (
        <div style={{ marginBottom: "auto" }}>
          <div
            style={{ fontSize: isLong ? "2rem" : "1.5rem", fontWeight: "600" }}
          >
            SDGs番号を選んでね!
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "55vh",
              }}
            >
              <div>
                <img
                  src={nine}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(9);
                  }}
                />
              </div>
              <div>
                <img
                  src={ten}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(10);
                  }}
                />
              </div>
              <div>
                <img
                  src={eleven}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(11);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={twelve}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(12);
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "55vh",
              }}
            >
              <div>
                <img
                  src={thirteen}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(13);
                  }}
                />
              </div>
              <div>
                <img
                  src={fourteen}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(14);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={fifteen}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(15);
                  }}
                />
              </div>
              <div>
                {" "}
                <img
                  src={sixteen}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(16);
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
              }}
            >
              <div>
                <Lottie
                  style={
                    isLong
                      ? {
                          width: "7rem",
                          height: "7rem",
                          margin: "auto",
                          cursor: "pointer",
                        }
                      : {
                          width: "5rem",
                          height: "5rem",
                          margin: "auto",
                          cursor: "pointer",
                        }
                  }
                  animationData={previousGIF}
                  onClick={() => {
                    pageChange(1);
                  }}
                ></Lottie>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "45%",
                justifyContent: "space-around",
                height: "15vh",
              }}
            >
              <div>
                {" "}
                <img
                  src={seventeen}
                  alt=""
                  className={isLong ? "number-icon" : "number-icon-short"}
                  onClick={() => {
                    goToAdvance(17);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          onClick={handleClose}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Lottie
              style={{ width: "20rem", height: "20rem" }}
              animationData={loadingImage}
            ></Lottie>
          </div>
        </Backdrop>
      </div>
    </div>
  );
};

export default SelectSDGsNum;
